import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import Tooltip from "@mui/material/Tooltip";
import i18n from "../../../../../public/i18n";
import { CircularProgress } from "@mui/material";

const CoreStatus = ({ status, testo, tooltip, isSingular }) => {
  let state = "";
  let testState = "";
  if (status === "InAttesa" || status === "In Attesa" || status === 3) {
    state = "#D86F07";
    testState =
      typeof status === "number" ? i18n.t("ToValidate") : i18n.t("Pending2");
  } else if (
    status === "Complete" ||
    status === "ChiusaPositivo" ||
    status === 5
  ) {
    state = "#359F1C";
    testState =
      typeof status === "number"
        ? isSingular
          ? i18n.t("Validated")
          : i18n.t("Validateds")
        : i18n.t("Closed");
  } else if (status === 2) {
    state = "#959595";
  } else if (status === "Annullata") {
    state = "#636363";
    testState = i18n.t("cancelled");
  } else if (
    status === "InLavorazione" ||
    status === "In Lavorazione" ||
    status === "Processed"
  ) {
    state = "#d8b207";
    testState = i18n.t("Pending");
  } else if (status === "Rejected" || status === "Aperta" || status === 6) {
    state = "#C1272D";
    testState =
      typeof status === "number" ? i18n.t("Discarded") : i18n.t("Open");
  }

  return (
    <>
      {testo ? (
        <p className="font-bold" style={{ color: `${state}` }}>
          {testState}
        </p>
      ) : status === 2 ? (
        <CircularProgress size={25} style={{ color: `${state}` }} />
      ) : (
        <Tooltip title={tooltip ? tooltip : testState}>
          <CircleRoundedIcon style={{ color: `${state}` }} />
        </Tooltip>
      )}
    </>
  );
};

export default CoreStatus;
